document.addEventListener('DOMContentLoaded', () => {
  class AppSectionHandler {
    constructor() {
      this.appSections = document.querySelectorAll('.shopify-section--apps');
      this.initialize();
    }

    initialize() {
      this.appSections.forEach(appSection => {
        if (this.containsKlaviyoElement(appSection)) {
          this.addKlaviyoClass(appSection);
        }
      });
    }

    containsKlaviyoElement(appSection) {
      const allElements = appSection.querySelectorAll('div');
      return Array.from(allElements).some(div => {
        const divId = div.getAttribute('id');
        return divId && divId.includes('klaviyo');
      });
    }

    addKlaviyoClass(appSection) {
      const section = appSection.querySelector('.section');
      if (section) {
        section.classList.add('section-klaviyo');
      }
    }
  }

  // Initialize the handler
  new AppSectionHandler();
});
